//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Banner from "@/components/banner";
  import ninePalaces from "@/components/block/ninePalaces.vue";
  import horizontalMin from "@/components/block/horizontalMin.vue";
  import verticalCircular from "@/components/block/verticalCircular.vue";
  import horizontalMax from "@/components/block/horizontalMax.vue";
  import marketingBlock from "@/components/marketingBlock.vue";

  export default {
    name: '',
    components:{
      Banner,
      ninePalaces,
      horizontalMin,
      verticalCircular,
      horizontalMax,
      marketingBlock
    },
    data() {
      return {
        tabActive: 0, //底部當前
        iconAll: {
          iconClose: require("@/assets/image/icon/close.png")
        },
        isShowClass: false,
        isloading: true,
        errData:{
          code: false
        },
        bannerData: [],
        bannerShow: false,
        menuData: [
          {type: 'audio', icon: require('@/assets/image/icon/icon_audio_book.png'), title: 'INDEX_LANG.menu.2'},
          {type: 'ebook', icon: require('@/assets/image/icon/icon_ebook.png'), title: 'INDEX_LANG.menu.3'},
          {type: 'course', icon: require('@/assets/image/icon/icon_start_course.png'), title: 'INDEX_LANG.menu.1'},
          {type: 'sayingbook', icon: require('@/assets/image/icon/icon_saying_book.png'), title: 'INDEX_LANG.menu.0'},
          {type: 'video', icon: require('@/assets/image/icon/icon_video.png'), title: 'INDEX_LANG.menu.4'}
        ],
        listD: [], //區塊列表
        //activityState: [true, true, true, true, true],
        activityList: [], //活动区块
        publicizeData: {
          index_top: "",
          index_top_activity: "",
          index_top_sayingBook: "",
          index_top_course: "",
          index_top_audioBook: "",
          index_top_celebrity: "",
          index_top_video: "",
          index_top_ebook: "",
          index_bottom: "",
          "app-lauch-dialog": ""
        } //广告位数据
      }
    },
    methods: {
      //区域数据
      getEbookInfo() {
        let postD = {
          appId: this.SERVER.APPID
        };
        //banner
        this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.BLOCK.GETPAGECODE, postD, "GET", "no login")
          .then(res => {
            console.log(res);
            this.isloading = false;

            let listD = [];
            let activityList = [];
            for (let i = 0; i < res.length; i++){
              //banner
              if(res[i].pageCode == 'index_banner'){
                if (res[i].items.length > 0) {
                  this.bannerShow = true;
                  this.bannerData = res[i].items;
                } else {
                  this.bannerShow = false;
                }
              }
              if(res[i].pageCode == 'index_ebook'){
                //console.log('res電子書',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].jumpUrl = 'morePage'; //跳转页面
                listD[0] = res[i];
              }
              //有聲書
              if(res[i].pageCode == 'index_audioBook'){
                //console.log('res有聲書',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].jumpUrl = 'morePage'; //跳转页面
                listD[1] = res[i];
              }
              //课程
              if(res[i].pageCode == 'index_course'){
                //console.log('res課程精選',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].number = 3; // 默認顯示條數
                res[i].template = 'verticalCircular';
                res[i].jumpUrl = 'morePage'; //跳转页面
                listD[2] = res[i];
              }
              //講書
              if(res[i].pageCode == 'index_talkbook'){
               //console.log('res講書精選',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].number = 3; // 默認顯示條數
                res[i].jumpUrl = 'morePage'; //跳转页面
                listD[3] = res[i];
              }
              //視頻
              if(res[i].pageCode == 'index_video'){
                //console.log('res細看香港',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].jumpUrl = 'morePage'; //跳转页面
                res[i].template = 'horizontalMax';
                listD[4] = res[i];
              }

              //活动
              if(res[i].pageCode == 'index_complex1'){
                //console.log('res活动1',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].jumpUrl = 'morePage'; //跳转页面
                res[i].template = 'horizontalMin';
                activityList[0] = res[i];
              }
              if(res[i].pageCode == 'index_complex2'){
                //console.log('res活动2',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].jumpUrl = 'morePage'; //跳转页面
                activityList[1] = res[i];
              }
              if(res[i].pageCode == 'index_complex3'){
                //console.log('res活动3',res[i]);
                res[i].blockName = res[i].pageName;
                res[i].jumpUrl = 'morePage'; //跳转页面
                activityList[2] = res[i];
              }

            }
            this.listD = listD;
            this.activityList = activityList;

            this.$forceUpdate();
            //console.log('listD',listD);
          }).catch(err => {
            if(err.response.data &&err.response.data.message){
                this.errData = err.response.data
              }
          });

      },
      //搜索
      onSearch(){
        this.$router.push({
          path: '/search'
        })
      },
      gotoPage(type) {
        this.$router.push({
          path: '/lists',
          query: {
            id: type
          }
        })
      },
      getCode(){
        let postD = {
          includeEmpty: false
        }
        this.GLOBAL_.ccRequest.doSessionAxios('h5/media/data/getPageConfig', {}, "GET","no login")
          .then(res => {
            console.log('getPageConfig',res)
            if(res){
              this.isShowClass = true
            }

          })
          .catch(err => {
            console.log(err);
          });
      },
      showMylinkTabClose(){
        const isAndroid = navigator.userAgent.match(/(android)/gi)// android终端
        const isiOS = navigator.userAgent.match(/(iphone|ipad|ipod|ios)/gi); // ios终端1

        let obj = {
          backVisible: true,
          right1icon: 'btn_ol_close',
          right1link: 'cmcchkh5action://close'
        }
        obj = JSON.stringify(obj)

        if (isAndroid) {
          // 获取登录后的boss信息
          window.HkAndroid && window.HkAndroid.setNavigationButtons(obj)
        }
        if (isiOS) {
          // 获取登录后的boss信息
          window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.setNavigationButtons 
          && window.webkit.messageHandlers.setNavigationButtons.postMessage(obj)
        }
        console.log('app navigator',isAndroid,isiOS,navigator.userAgent)
    }
    },
    created() {
    },
    mounted(){
      this.getCode();
      this.getEbookInfo();
      if(this.SERVER.APPID == 'mylink'){
        this.showMylinkTabClose()
      }
    },
    activated(){
      if(this.SERVER.APPID == 'mylink'){
        this.showMylinkTabClose()
      }
    }

  }



// WEBPACK FOOTER //
// ./src/pages/home.vue